module.exports = __webpack_public_path__ + "static/media/desktop.76aea4fe.svg";